var _path, _rect, _rect2, _mask, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMobileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "1.5 3 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89 3.164h11.485c.897 0 1.64.743 1.64 1.64v7.383c0 .923-.743 1.641-1.64 1.641H9.863l.257.82h1.794c.436 0 .82.385.82.82 0 .462-.384.821-.82.821H5.352a.81.81 0 0 1-.82-.82c0-.436.358-.82.82-.82H7.12l.282-.82H2.891a1.62 1.62 0 0 1-1.641-1.642V4.806c0-.898.718-1.64 1.64-1.64zm11.485 1.64H2.891v5.743h11.484V4.805z",
    fill: "#233145"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.688,
    y: 6.492,
    width: 7.563,
    height: 10.844,
    rx: 1.75,
    fill: "#233145"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.688,
    y: 6.492,
    width: 7.563,
    height: 10.844,
    rx: 1.75,
    stroke: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "4s28k2nw6a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.188,
    y: 6.992,
    width: 6.563,
    height: 10,
    rx: 1.25
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.188,
    y: 6.992,
    width: 6.563,
    height: 10,
    rx: 1.25,
    fill: "#fff",
    stroke: "#233145",
    strokeWidth: 3.75,
    mask: "url(#4s28k2nw6a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMobileIcon);
export default __webpack_public_path__ + "static/media/desktop_mobile-icon.7d5c6a9f.svg";
export { ForwardRef as ReactComponent };